
// Animera Label
'use strict';

$(function () {
    $.fn.phAnim = function () {
        var label;
        var ph;

        function getLabel(element) {
            return $(element).parent().find('label');
        }

        function makeid() {
            var text = '';
            var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖabcdefghijklmnopqrstuvwxyzåäö';
            for (var i = 0; i < 5; i++) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return text;
        }

        return this.each(function () {
            if ($(this).attr('id') === undefined) {
                $(this).attr('id', makeid());
            }

            if (getLabel($(this)).length === 0) {
                if ($(this).attr('placeholder') !== undefined) {
                    ph = $(this).attr('placeholder');
                    $(this).attr('placeholder', '');
                    $(this).parent().prepend('<label for=' + $(this).attr('id') + '>' + ph + '</label>');
                }
            } else {
                $(this).attr('placeholder', '');
                if (getLabel($(this)).attr('for') === undefined) {
                    if ($(this).attr('type') !== 'hidden') {
                        getLabel($(this)).attr('for', $(this).attr('id'));
                    }
                }
            }
            $(this).on('focus', function () {
                label = getLabel($(this));
                label.addClass('active focusIn');
            }).on('focusout', function () {
                if (label !== null) {
                    if ($(this).val() === '') {
                        if (label !== undefined) {
                            label.removeClass('active');
                        }
                    }

                    if (label !== undefined) {
                        label.removeClass('focusIn');
                    }
                }
            });
        });
    };
});

$(function () {
    $('input').phAnim();
    $('textarea').phAnim();
    $('jquerytextarea').phAnim();
});

// AutoGrow Textarea
$(function () {
    /* eslint-disable */
    if ($('textarea').length > 0) {
        var ta = document.querySelector('textarea');
        ta.addEventListener('focus', function () {
            autosize(ta);
        });
    }
    //$('textarea').trigger('autosize.destroy');
    /* eslint-enable */
});

// Forms :: Checkbox/Radiobutton
$(function () {
    $('.FormChoice input').iCheck({
        checkboxClass: 'alecta-checkbox',
        radioClass: 'alecta-radiobutton'
    });
});

// Forms :: Select
$(function () {
    $('select:not(.no-selectric)').selectric({
        maxHeight: 400
    });
});

// Forms :: Input - Om fältet har ett värde (value), flyttar label upp.
$('input').each(function (index, item) {
    if ($(item).val() !== '') {
        $(this).siblings('label').addClass('active');
    }
});

// Forms :: personnummersök/spinner
$(function () {
    $('button#personnummersok-submitbutton').removeClass('knapp-laddar');

    $('button#personnummersok-submitbutton').click(function () {
        $('button#personnummersok-submitbutton').addClass('knapp-laddar');
    });
});
